export default __webpack_public_path__ + "static/media/picture_text.4dbf3e30.png";